import { useState, useCallback } from 'react';
import './App.css';
import Home from './components/Home';
import IntroVideo from './components/IntroVideo';
import Loader from './components/Loader';

function App() {
  const [phase, setPhase] = useState('intro'); // 'intro' | 'loading' | 'ready'
  const [loaderFading, setLoaderFading] = useState(false);

  const handleVideoEnd = useCallback(() => {
    setPhase('loading');
  }, []);

  const handleSplineReady = useCallback(() => {
    // Spline loaded — fade out the loader
    setLoaderFading(true);
    setTimeout(() => setPhase('ready'), 900);
  }, []);

  if (phase === 'intro') {
    return <IntroVideo onVideoEnd={handleVideoEnd} />;
  }

  return (
    <>
      {/* Layer 3 (bottom): Actual Home page content */}
      <div style={{
        position: 'relative',
        zIndex: 1,
        opacity: phase === 'ready' ? 1 : 0,
        transition: 'opacity 0.8s ease-in',
      }}>
        <Home onSplineLoad={handleSplineReady} />
      </div>

      {/* Layer 2 (middle): Spline processing layer - hidden, isolates heavy rendering */}
      {/* Spline loads inside Home above; this layer purely exists as a visual barrier */}

      {/* Layer 1 (top): Loader - CSS-only animations on compositor thread */}
      {phase === 'loading' && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            zIndex: 9999,
            opacity: loaderFading ? 0 : 1,
            transition: 'opacity 0.8s ease-out',
            pointerEvents: loaderFading ? 'none' : 'auto',
            willChange: 'opacity',
            contain: 'strict',
          }}
        >
          <Loader />
        </div>
      )}
    </>
  );
}

export default App;
